import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { RunStatus } from "@/types/tina";

const STYLES: Record<RunStatus, string> = {
  queued: "bg-muted text-foreground",
  running: "bg-blue-500/15 text-blue-700 dark:text-blue-300",
  done: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300",
  failed: "bg-red-500/15 text-red-700 dark:text-red-300",
  cancelled: "bg-zinc-500/15 text-zinc-700 dark:text-zinc-300",
};

export function RunStatusBadge({ status }: { status: RunStatus }) {
  return <Badge className={cn(STYLES[status])}>{status}</Badge>;
}
